import React, { useRef } from "react";
import HeroSection from "./components/HeroSection";
import { FirstBanner } from "../LandingPage/FirstBanner";
import { Testimonials } from "../LandingPage/Testimonials";
import SaddleSelectionControls from "./components/SaddleSelectionControls";
import { useAuthStore } from "stores/auth/authStore";

export const BuySaddles = () => {
  const controlsRef = useRef(null);
  const subdomain = useAuthStore(state => state.domain);
  
  return (
    <>
      <HeroSection scrollRef={controlsRef} />
      <SaddleSelectionControls isCactus={subdomain?.toLowerCase?.() === "cactus"} ref={controlsRef} />
      <Testimonials />
      <FirstBanner type="BUY_SADDLE" />
    </>
  );
};
